var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    "aria-label": "Twitter X icon"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "var(--color-secondary-dark)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.79 10.324h2.681l-5.858 6.696 6.892 9.112h-5.397l-4.226-5.526-4.837 5.526H9.362l6.266-7.162-6.611-8.646h5.533l3.82 5.051zm-.941 14.203h1.486l-9.592-12.682h-1.595z"
  })));
}
export default SvgTwitterX;